module.exports = __webpack_public_path__ + "static/media/0008.3a2fe47e.png";